<template>
    <div class="brief-preview-page" v-wechat-title="`${pageTitle}_双优云桥-智慧研修平台`">
        <div class="preview-bar">
            <div class="preview-bar-inner">
                <div class="preview-info">
                    <div class="crumb-bar">
                        <a href="javascript:;" @click.prevent="goHome">项目首页</a>
                        <template v-if="fromList">
                            <span class="sep">/</span>
                            <a href="javascript:;" @click.prevent="goList">项目简报</a>
                        </template>
                        <span class="sep">/</span>
                        <span class="cur">PDF 预览</span>
                    </div>
                    <h1 class="preview-title">{{ briefName || '周报预览' }}</h1>
                    <p class="preview-meta" v-if="briefDate || briefName">
                        <span v-if="briefDate">发布日期：{{ briefDate }}</span>
                        <span v-if="briefDate"> · </span>
                        <span>PDF</span>
                    </p>
                </div>
                <div class="preview-actions">
                    <button type="button" class="btn btn-ghost" @click="goBack">
                        {{ fromList ? '返回列表' : '返回首页' }}
                    </button>
                    <button
                        v-if="identifier"
                        type="button"
                        class="btn btn-primary"
                        @click="downloadPDF"
                    >
                        <i class="el-icon-download"></i>下载 PDF
                    </button>
                </div>
            </div>
        </div>

        <div class="pdf-wrap" v-loading="loading" element-loading-text="正在加载 PDF...">
            <template v-if="identifier && !loadError && totalPage > 0">
                <pdf :src="src" v-for="i in totalPage" :key="i" :page="i"></pdf>
            </template>
            <div v-else-if="!loading" class="pdf-empty">
                <ph-empty
                    size="page"
                    :text="loadError || '周报不存在或已被删除'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pdf from 'vue-pdf'
import PhEmpty from './components/ph-empty.vue'

export default {
    name: 'ProjectHomeBriefPreview',
    components: { pdf, PhEmpty },
    data() {
        return {
            loading: true,
            loadError: '',
            totalPage: 0,
            src: undefined
        }
    },
    computed: {
        ...mapState({
            fileToken: state => state.user.fileToken
        }),
        projectId() {
            return this.$route.params.id
        },
        identifier() {
            return this.$route.query.identifier || ''
        },
        briefName() {
            return this.$route.query.name || ''
        },
        briefDate() {
            return this.$route.query.date || ''
        },
        fromList() {
            return this.$route.query.from === 'list'
        },
        pageTitle() {
            return this.briefName || '周报预览'
        }
    },
    methods: {
        goHome() {
            this.$router.push(`/projectHome/${this.projectId}`)
        },
        goList() {
            this.$router.push(`/projectHome/${this.projectId}/brief`)
        },
        goBack() {
            if (this.fromList) {
                this.goList()
            } else {
                this.goHome()
            }
        },
        downloadPDF() {
            if (!this.identifier) return
            window.open(
                `${this.downloadURL}${this.identifier}&token=${this.fileToken}&type=2`
            )
        },
        loadingTask() {
            if (!this.identifier) {
                this.loading = false
                this.loadError = '周报不存在或已被删除'
                this.totalPage = 0
                return
            }
            this.loading = true
            this.loadError = ''
            this.totalPage = 0
            this.src = pdf.createLoadingTask(this.downloadURL + this.identifier)
            this.src.promise
                .then(doc => {
                    this.loading = false
                    this.totalPage = doc.numPages
                })
                .catch(() => {
                    this.loading = false
                    this.totalPage = 0
                    this.loadError = 'PDF 加载失败，请稍后重试'
                })
        }
    },
    mounted() {
        this.loadingTask()
    },
    watch: {
        '$route.query.identifier'() {
            this.totalPage = 0
            this.loadingTask()
        }
    }
}
</script>

<style lang="less" scoped>
.brief-preview-page {
    background: #f5f7fa;
    min-height: 60vh;
    padding-bottom: 40px;
    line-height: 1.5;
}

.preview-bar {
    background: #fff;
    border-bottom: 1px solid rgba(199, 199, 199, 0.4);
    padding: 16px 0;
    position: sticky;
    top: 0;
    z-index: 10;
}

.preview-bar-inner {
    width: 990px;
    max-width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
}

.preview-info {
    min-width: 0;
    flex: 1;
}

.crumb-bar {
    font-size: 13px;
    color: #999;
    margin-bottom: 8px;

    a {
        color: #01A2FD;
        text-decoration: none;
    }

    .sep {
        margin: 0 8px;
        color: #ccc;
    }

    .cur {
        color: #666;
    }
}

.preview-title {
    margin: 0 0 6px;
    font-size: 18px;
    font-weight: 400;
    color: #333;
    line-height: 1.4;
}

.preview-meta {
    margin: 0;
    font-size: 12px;
    color: #999;
}

.preview-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 4px;
    font-size: 13px;
    font-family: inherit;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border: 1px solid transparent;
    line-height: 1;
}

.btn-ghost {
    background: #fff;
    border-color: #dcdfe6;
    color: #666;

    &:hover {
        color: #01A2FD;
        border-color: #01A2FD;
    }
}

.btn-primary {
    background: #01A2FD;
    border-color: #01A2FD;
    color: #fff;

    &:hover {
        background: #0191E3;
        border-color: #0191E3;
    }
}

.pdf-wrap {
    width: 990px;
    max-width: 100%;
    margin: 20px auto 0;
    background: #fff;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 4px;
    min-height: 640px;
    padding: 16px;
    box-sizing: border-box;
}

.pdf-empty {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}

@media screen and (min-width: 1250px) {
    .preview-bar-inner,
    .pdf-wrap {
        width: 1200px;
    }
}
</style>
